import styled from "styled-components";

export const ShadowBackground = styled.div`
	position: fixed;
	top: 0;
	overflow: auto;
	left: 0;
	background-color: rgba(0, 0, 0, 0.4);
	width: 100%;
	height: 100%;
	z-index: 1050;
`;

export const InOfFlow = styled.div`
	width: 100%;
	height: 50px;
	@media (min-width: 500px) {
		height: 75px;
	}
	@media (min-width: 1024px) {
		padding-top: 100px;
	}
	@media (min-width: 1280px) {
		padding-top: 150px;
	}
	@media (min-width: 1536px) {
		display: none;
	}
`;

export const WrapperContainer = styled.div`
	padding-top: 100px;
	margin: 0 10px;

	@media (min-width: 500px) {
		padding-top: 150px;
	}
	@media (min-width: 1024px) {
		padding-top: 200px;
	}
	@media (min-width: 1280px) {
		padding-top: 225px;
	}
	@media (min-width: 1536px) {
		padding-top: 337px;
	}
`;

export const Container = styled.div`
	position: absolute;
	width: 100%;
	min-height: 100px;
	max-width: 100%;
	max-height: calc(100vh - 64px);
	overflow-y: auto;
	@media (min-width: 600px) {
		width: 600px;
		padding: 30px 20px;
	}
	@media (min-width: 1024px) {
		width: 700px;
		padding: 40px 30px;
	}
	@media (min-width: 1280px) {
		width: 800px;
		padding: 50px 40px;
		margin-left: 300px;
	}
	@media (min-width: 1536px) {
		width: 915px;
		padding: 68px 80px;
		min-height: 432px;
	}
	background: #ffffff;
	box-shadow: 5px 5px 10px #0000000d;
	border: 1px solid #d9d9d9;
	border-radius: 5px;
	opacity: 1;
	padding: 10px 10px;
	&:hover #close {
		cursor: pointer;
	}
`;
